const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        pharmacyBadge: "Atención al cliente",
        subtitle: "Ingrese con su cuenta para continuar",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          reconfigured: "La sesión se reconfiguró en WAHA.",
          reconfigureOk: "La configuración de la sesión ya estaba correcta.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido. También se eliminará la sesión en WAHA.",
          disconnectTitle: "Cerrar sesión",
          disconnectMessage: "¿Estás seguro? Tendrás que volver a vincular el dispositivo con QR o código.",
          stopTitle: "Detener sesión",
          stopMessage: "¿Detener esta línea? Dejará de recibir y enviar mensajes hasta que la reinicies.",
        },
        buttons: {
          add: "Agregar WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
          login: "Iniciar sesión",
          restart: "Reiniciar",
          stop: "Detener",
          logout: "Cerrar sesión",
          reconfigure: "Reconfigurar",
          edit: "Editar",
          delete: "Borrar",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
          error: {
            title: "La sesión falló",
            content:
              "Se intentará reiniciar automáticamente si hay alguien usando el CRM. Si no vuelve, cierre sesión y vincule de nuevo.",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agregar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
          nameHint: "Se normalizará para WAHA (sin espacios, acentos ni símbolos).",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        title: "Vincular WhatsApp",
        message: "Lee el código QR para empezar la sesión.",
        waiting: "Esperando código QR…",
        tabs: {
          qr: "Código QR",
          code: "Código",
        },
        codeMessage: "Ingresa el número con código de área y solicita el código.",
        country: "País",
        phone: "Número de teléfono",
        requestCode: "Solicitar código",
        codeHint: "En WhatsApp: Dispositivos vinculados → Vincular con número de teléfono. Este método no usa el nombre CRM WA (WhatsApp lo rechaza en el código).",
        invalidPhone: "Ingresa un número válido (mínimo 8 dígitos).",
      },
      contacts: {
        unknownNumber: "Sin número",
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar por nombre, teléfono, email o cliente ERP…",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        tabs: {
          text: "Texto",
          media: "Media",
          location: "Ubicación",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          title: "Título (interno)",
          mediaType: "Tipo de archivo",
          mediaFile: "Imagen / Video / Archivo",
          caption: "Descripción o pie de foto",
          mapsUrl: "URL de Google Maps",
          locationName: "Nombre del lugar",
          locationCaption: "Descripción",
        },
        mediaTypes: {
          image: "Imagen",
          video: "Video",
          file: "Archivo",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      chatPresence: {
        typing: "escribiendo…",
        recording: "grabando audio…",
        online: "en línea",
        lastSeen: "última vez {{time}}",
        minuteAgo: "hace 1 minuto",
        minutesAgo: "hace {{count}} minutos",
        yesterday: "ayer",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Colas",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar mensajes, contactos o cliente ERP…",
          typeToSearch: "Escribe para buscar en mensajes, nombres de contacto o cliente ERP.",
          noResults: "No se encontraron mensajes.",
          inChat: "Buscar en el chat",
          contactMatch: "contacto",
          contactMatchHint: "Coincidencia por nombre de contacto o cliente ERP",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir a conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        groupsHeader: "Grupos",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Aceptar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Buscar por cliente, empresa o teléfono",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          agentChat: "Chat entre agentes",
          more: "Más",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Colas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Colas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Colas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        tabs: {
          all: "Todas",
          text: "Texto",
          media: "Media",
          location: "Ubicación",
        },
        table: {
          type: "Tipo",
          shortcut: "Atajo",
          title: "Título",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
        resolvePending: {
          title: "Tickets en cola",
          description: "Marca todos los tickets pendientes (cola) como resueltos. Los grupos no se cierran.",
          button: "Resolver tickets pendientes",
          confirming: "Resolviendo…",
          confirmTitle: "Resolver todos los tickets en cola",
          confirmMessage: "¿Resolver todos los tickets pendientes? Pasarán a resueltos. Esta acción no se puede deshacer.",
          success: "Se resolvieron {{count}} tickets pendientes.",
        },
      },
      ticketInfo: {
        buttons: {
          editClient: "Editar cliente",
          createClient: "Crear cliente",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
        editMessage: "Editar mensaje",
        editMessageDialogTitle: "Editar mensaje",
        editMessageError: "Mensaje ya no se puede editar",
        edited: "editado",
        reactToMessage: "Reaccionar",
        removeReaction: "Quitar reacción",
        download: "Descargar",
        preview: "Vista previa",
        unavailableMedia: "Archivo no disponible",
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje (Shift+Enter para enviar). Presione ''/'' para respuestas rápidas.",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        audioTooShort: "La grabación es muy corta. Mantén presionado el micrófono un momento más.",
        audioMicError: "No se pudo usar el micrófono. Revisa el permiso del navegador e inténtalo de nuevo.",
        audioUnsupported: "Este navegador no permite grabar audio.",
        quickReplyPicker: {
          searchPlaceholder: "Buscar por título...",
          tabs: {
            all: "Todas",
            text: "Texto",
            media: "Media",
            location: "Ubicación",
          },
          noResults: "No hay respuestas rápidas",
        },
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        forward: "Reenviar",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      forward: {
        titleSelectMessages: "Reenviar mensajes",
        titleSelectRecipients: "Seleccionar destinatarios",
        titleSuccess: "Reenviado",
        selectMessagesHint: "Selecciona los mensajes a reenviar",
        noMessages: "Sin mensajes",
        searchHint: "Busca por número, nombre de contacto, cliente ERP o grupo",
        searchPlaceholder: "Buscar...",
        noResults: "Sin resultados",
        typeToSearch: "Escribe para buscar",
        group: "Grupo",
        cancel: "Cancelar",
        back: "Atrás",
        forwardSelected: "Reenviar ({{count}} seleccionados)",
        forwardTo: "Reenviar a ({{count}} seleccionados)",
        sentSuccess: "Mensajes reenviados correctamente",
        optionalMessageLabel: "Mensaje opcional",
        optionalMessagePlaceholder: "Escriba un mensaje adicional para enviar después de los mensajes reenviados",
      },
      internalChat: {
        title: "Chat entre agentes",
        noChatMessage: "Seleccione una conversación o inicie una nueva.",
        noChatsTitle: "¡Nada acá!",
        noChatsMessage: "No hay conversaciones. Inicie un chat directo o cree un grupo.",
        buttons: {
          newDM: "Nuevo chat directo",
          newGroup: "Nuevo grupo",
          cancel: "Cancelar",
          start: "Iniciar",
          create: "Crear",
        },
        dmModal: {
          title: "Iniciar chat directo",
          userLabel: "Usuario",
        },
        groupModal: {
          title: "Crear grupo",
          nameLabel: "Nombre del grupo",
          membersLabel: "Miembros",
        },
        header: {
          conversation: "Conversación",
        },
        input: {
          placeholder: "Escriba un mensaje (Shift+Enter para enviar)",
        },
        searchPlaceholder: "Buscar conversaciones...",
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhatsApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
        ERR_NO_INTERNAL_CHAT_FOUND: "No se encontró ningún chat interno con este ID.",
      },
    },
  },
};

export { messages };
